import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext.tsx";
import { AnimatedLoading } from "./widgets/AnimatedLoading.tsx";

/**
 * ProtectedRoute - Protects routes that require authentication
 * Redirects unauthenticated users to /login
 */
export const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AnimatedLoading />;
  }

  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

/**
 * PublicRoute - Protects routes that should only be accessible when logged out
 * Redirects authenticated users to home page (/)
 */
export const PublicRoute = ({ children }: { children: ReactNode }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <AnimatedLoading />;
  }

  return user ? <Navigate to="/" replace /> : <>{children}</>;
};
